import React from 'react';
import { View, StyleSheet, Text } from 'react-native';
import { useTranslation } from 'react-i18next';
import { usePantryName } from '../usePantryName';
import { BottomSheet } from '../../weekly/v2/primitives/BottomSheet';
import { ZonePicker } from '../ZonePicker';
import { ZONE_META } from '../zoneMeta';
import { Paprika } from '../../../styles/theme';
import { InventoryItem } from '../../../redux/inventorySlice';
import { PantryLocation } from '../../../utils/pantryLocation';
import { PantryActions } from '../usePantryActions';

interface Props {
  visible: boolean;
  onClose: () => void;
  item: InventoryItem | null;
  actions: PantryActions;
}

export function MoveSheet({ visible, onClose, item, actions }: Props) {
  const { t } = useTranslation();
  const pantryName = usePantryName();

  if (!item) return null;

  const currentZone = item.location || 'fridge';

  const handleMove = (zone: PantryLocation) => {
    actions.moveTo(item, zone);
    onClose();
  };

  return (
    <BottomSheet visible={visible} onClose={onClose}>
      <View style={styles.container}>
        <Text style={styles.title}>{t('pantry.item.moveTitle', { name: pantryName(item) })}</Text>
        <Text style={styles.subtitle}>
          {t('pantry.item.moveSub', { zone: t(ZONE_META[currentZone].labelKey).toLowerCase() })}
        </Text>

        <ZonePicker food={item} current={currentZone} onPick={handleMove} />
      </View>
    </BottomSheet>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 16,
  },
  title: {
    fontFamily: 'Inter-SemiBold',
    fontSize: 11,
    fontWeight: '700',
    letterSpacing: 0.05,
    textTransform: 'uppercase',
    color: Paprika.textMuted,
    marginBottom: 4,
  },
  subtitle: {
    fontFamily: 'Inter-Regular',
    fontSize: 12,
    color: Paprika.textMuted,
    marginBottom: 13,
  },
});
